export default "__VITE_ASSET__DsfbJKoW__"